<script>
  export default {
    name: 'Mobilizev2PreviewAds'
  }
</script>

<template>
  <div class="mobilizev2-view">
    <h1>Preview Your Ads</h1>
  </div>
</template>

<style lang="scss" scoped>
</style>
